import moment from 'moment'

export const isViewedToday = (lastViewedAt: Date | null | undefined): boolean =>
  lastViewedAt != null && moment(lastViewedAt).isSame(moment(), 'day')

/**
 * A view keeps the bar up for the rest of the calendar day, including after a new patient
 * message. It hides while a reply is still a draft and again the next day. Marking the feed
 * unread hides it too, because the server then reports no `lastViewedAt`.
 */
export const shouldShowViewedTodayIndicator = (
  lastViewedAt: Date | null | undefined,
  hasDraftMessage: boolean
): boolean => isViewedToday(lastViewedAt) && !hasDraftMessage
